import { Icon } from "../icons/icon";

export const WebsiteFooter = () => {
  return (
    <div className={`bg-pry-dark-green-200 padding-x py-[56px]`}>
      <div
        className="
        max-w-full md:max-w-max-1024 width-lim:max-w-website-max width-lim-xl:max-w-website-max-xl
        mx-auto text-white text-base
        "
      >
        <Icon svg={"tc-logo"} width={163} height={28} />

        <div
          className="
          mt-[56px] md:mt-[48px]
          flex flex-col lg:flex-row flex-wrap gap-4
          lg:items-center justify-between
          "
        >
          <p className="order-3 lg:order-1">
            © {new Date().getFullYear()} Thriftcorp. All rights reserved
          </p>

          <p className="order-2">Contact us: contact@thriftcorp.co</p>

          <div className="order-1 lg:order-3 flex flex-row items-center gap-2">
            <Icon svg={"facebook-icon"} width={20} height={20} />

            <Icon svg={"twitter-icon"} width={20} height={20} />

            <Icon svg={"instagram-icon"} width={20} height={20} />

            <Icon svg={"linkedin-icon"} width={20} height={20} />

            <p>@thriftcorp</p>
          </div>
        </div>
      </div>
    </div>
  );
};
